export default "__VITE_ASSET__Dp$1vwWM__"